import { Loader2 } from "lucide-react";
import "./_loading-screen.scss";

export function LoadingScreen() {
	return (
		<div className="loading-screen">
			<div className="loading-screen__content">
				<div className="loading-screen__icon-container">
					<Loader2 className="loading-screen__spinner" size={48} />
				</div>
				<h2 className="loading-screen__text">Cargando WhatMix…</h2>
				<p className="loading-screen__subtext">Preparando tu experiencia</p>
			</div>
		</div>
	);
}
